<!--
  商家列表
  lovi 2020-07-15
-->
<template>
  <div class="store-list" @click="_linkFun('/store?shopId=' + data.shop_id)">
    <div class="logo">
      <img :src="httpUrl + data.logo" />
    </div>
    <div class="info">
      <div class="tit">
        <h3 class="text-hidden">{{ data.shop_name }}</h3>
        <span v-if="data.is_delivery" class="delivery">
          {{ $t("life.deliverable") }}
        </span>
      </div>
      <p class="text-gray cost-info">
        <span>
          {{ $t("life.freeDelivery") }}
          {{ data.starting_price }}P
        </span>
        <span>
          {{ $t("life.deliveryFee") }}
          {{ data.delivery_fee }}P
        </span>
        <span>
          {{ $t("life.packingFee") }}
          {{ data.packaging_fee }}P
        </span>
      </p>
      <p class="description" v-if="data.ad_text">
        <span class="text-orange text-hidden">
          {{ data.ad_text }}
        </span>
      </p>
      <p class="activity text-hidden" v-if="data.activity.length">
        <span v-for="(activity, index1) in data.activity" :key="index1">
          {{ activity.name }}
        </span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["data"],
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {},
  watch: {}
};
</script>

<style lang="less" scoped>
.store-list {
  margin-top: 10px;
  display: flex;
  justify-content: flex-start;
  padding: 10px;
  background: #fff;
  border-radius: 10px;
  .logo {
    margin-right: 10px;
    width: 70px;
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    overflow: hidden;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
  .info {
    flex: 1;
    overflow: hidden;
    .tit {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      h3 {
        flex: 1;
        font-size: 14px;
        font-weight: 400;
        line-height: 16px;
      }
      .delivery {
        margin-left: 10px;
        padding: 0 5px;
        font-size: 10px;
        line-height: 1.4;
        color: #2042ab;
        border: 1.1px solid #2042ab;
        border-radius: 4px;
      }
    }
    .cost-info {
      span {
        margin-right: 5px;
      }
    }
    .description {
      padding-top: 5px;
      display: flex;
      justify-content: flex-start;
      overflow: hidden;
      span {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 16px;
        line-height: 1;
        padding: 0 2px;
        background: #ffe1de;
        border-radius: 3px;
      }
    }
    .activity {
      padding-top: 5px;
      display: flex;
      justify-content: flex-start;
      span {
        margin-right: 5px;
        padding: 0 5px;
        color: #fd4553;
        border: 1.1px solid #fd4553;
        border-radius: 3px;
      }
    }
  }
}
</style>
